import { ExtractSignalType } from './extract-class';
import { SignalModel } from './signal.model';

export abstract class SignalGroupModel {
  toJson<T extends SignalGroupModel>(): ExtractSignalType<T> {
    const json = { ...this };

    return Object.fromEntries(
      Object.entries(json).map((item) => {
        const value =
          item[1] instanceof SignalModel || item[1] instanceof SignalGroupModel ? item[1].toJson() : item[1];

        return [item[0], value];
      })
    ) as ExtractSignalType<T>;
  }
}
